'use strict';

const NEXTFLOW_PROCESS_LIFECYCLE_STATUS = Object.freeze({
  NOT_STARTED: 'NOT_STARTED',
  WAITING: 'WAITING',
  SUBMITTED: 'SUBMITTED',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  CACHED: 'CACHED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
  UNKNOWN: 'UNKNOWN',
});

const NEXTFLOW_PROCESS_TIMELINE_STATE = Object.freeze({
  PENDING: 'pending',
  ACTIVE: 'active',
  ERROR: 'error',
  DONE: 'done',
  SKIPPED: 'skipped',
});

const TIMELINE_STATE_BY_LIFECYCLE_STATUS = Object.freeze({
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.NOT_STARTED]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.PENDING,
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.WAITING]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.PENDING,
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.SUBMITTED]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.ACTIVE,
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.RUNNING]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.ACTIVE,
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.COMPLETED]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.DONE,
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.CACHED]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.DONE,
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.FAILED]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.ERROR,
  // A skipped stage is terminal, not waiting. Rendering it as PENDING made an
  // UPSTREAM_FAILED stage look like it was still queued on a run that had
  // already failed.
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.SKIPPED]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.SKIPPED,
  [NEXTFLOW_PROCESS_LIFECYCLE_STATUS.UNKNOWN]:
    NEXTFLOW_PROCESS_TIMELINE_STATE.PENDING,
});

// Historical tasks persisted the producer result outcome in `status` before
// lifecycle status and `resultStatus` became separate fields. Keep those
// already-stored records readable, but do not use these aliases for new data.
const TIMELINE_STATE_BY_LEGACY_RESULT_STATUS = Object.freeze({
  success: NEXTFLOW_PROCESS_TIMELINE_STATE.DONE,
  failure: NEXTFLOW_PROCESS_TIMELINE_STATE.ERROR,
  partial_success: NEXTFLOW_PROCESS_TIMELINE_STATE.PENDING,
  unknown: NEXTFLOW_PROCESS_TIMELINE_STATE.PENDING,
});

/**
 * Convert the backend-owned process lifecycle status into a timeline state.
 *
 * New data uses the separate lifecycle `status` populated from workflow-plan
 * and trace evidence. Lower-case result outcomes are accepted only so tasks
 * persisted before `resultStatus` was introduced remain readable.
 */
function nextflowProcessTimelineState(status) {
  return (
    TIMELINE_STATE_BY_LIFECYCLE_STATUS[status] ||
    TIMELINE_STATE_BY_LEGACY_RESULT_STATUS[status] ||
    NEXTFLOW_PROCESS_TIMELINE_STATE.ERROR
  );
}

module.exports = {
  NEXTFLOW_PROCESS_LIFECYCLE_STATUS,
  NEXTFLOW_PROCESS_TIMELINE_STATE,
  nextflowProcessTimelineState,
};
